module.exports = __webpack_public_path__ + "img/logo.1df22577.png";